import { getInitialValues } from "layouts/views/common/common";
import * as Yup from "yup";

const formField = {
  warehouseCode: {
    name: "warehouseCode",
    label: "Warehouse Code",
    type: "select",
    errorMsg: "Warehouse Code is required.",
    required: true,
    editable: false,
  },
  zoneID: {
    name: "zoneID",
    label: "Zone ID",
    type: "text",
    errorMsg: "Zone ID is required.",
    required: true,
    editable: false,
    maxLength: 20,
  },
  floor: {
    name: "floor",
    label: "Floor",
    type: "text",
  },
  zoneType: {
    name: "zoneType",
    label: "Zone Type",
    type: "select",
    errorMsg: "Zone Type is required.",
    required: true,
  },
  descriptions1: {
    name: "descriptions1",
    label: "Descriptions1",
    type: "text",
    errorMsg: "Descriptions 1 is required.",
    required: true,
    maxLength: 100,
  },
  descriptions2: {
    name: "descriptions2",
    label: "Descriptions2",
    type: "text",
  },
  nonBonded: {
    name: "nonBonded",
    label: "Non Bonded",
    type: "switch",
    default: true,
  },
  chargeStorage: {
    name: "chargeStorage",
    label: "Charge Storage",
    type: "switch",
    default: false,
  },
};
export const form = {
  formId: "new-zone-form",
  formField,
  formRender: [
    [
      {
        name: "warehouseCode",
        label: "Warehouse Code",
        type: "select",
        errorMsg: "Warehouse Code is required.",
        required: true,
        disabled: true,
        xs: 6,
      },
      {
        name: "zoneID",
        label: "Zone ID",
        type: "text",
        errorMsg: "Zone ID is required.",
        required: true,
        disabled: true,
        xs: 6,
        maxLength: 20,
      },
    ],
    [
      {
        name: "floor",
        label: "Floor",
        type: "text",
        xs: 6,
      },
      {
        name: "zoneType",
        label: "Zone Type",
        type: "select",
        errorMsg: "Zone Type is required.",
        required: true,
        xs: 6,
      },
    ],
    [
      {
        name: "descriptions1",
        label: "Descriptions1",
        type: "text",
        errorMsg: "Descriptions 1 is required.",
        required: true,
        xs: 6,
        maxLength: 100,
      },
    ],
    [
      {
        name: "descriptions2",
        label: "Descriptions2",
        type: "text",
        xs: 6,
      },
    ],
    [
      {
        name: "nonBonded",
        label: "Non Bonded",
        type: "switch",
      },
      {
        name: "chargeStorage",
        label: "Charge Storage",
        type: "switch",
      },
    ],
  ],
};

const {
  warehouseCode,
  zoneID,
  zoneType,
  descriptions1,
  floor,
  descriptions2,
  nonBonded,
  chargeStorage,
} = formField;

export const formRender = [
  [warehouseCode, zoneID],
  [floor, zoneType],
  [descriptions1, descriptions2],
  [nonBonded, chargeStorage],
];

export const initialValues = getInitialValues(formField);

export const zoneValidations = Yup.object().shape({
  [warehouseCode.name]: Yup.string().nullable().max(20).required(warehouseCode.errorMsg),
  [zoneID.name]: Yup.string().max(20).required(zoneID.errorMsg),
  [zoneType.name]: Yup.string().nullable().max(20).required(zoneType.errorMsg),
  [descriptions1.name]: Yup.string().max(100).required(descriptions1.errorMsg),
});
